<template>
  <div>
    <div class="action-buttons">
      <!-- TODO: Temporarily hidden — feature not yet available from the gamification backend -->
      <el-button
        v-if="false"
        type="primary"
        :disabled="isReadOnly"
        data-qa="download-data-btn"
        >{{ $t('Gamification_GameStepAnalytics_DownloadData') }}</el-button
      >
    </div>
    <rest-list
      ref="fixturesList"
      :loading="isLoading"
      :payload="fetchEndpoint"
      :empty-text="$t('Gamification_GameStepAnalytics_NoData')"
      :data-handler="extractData"
    >
      <rest-list-column
        prop="participant1.name"
        :title="$t('Gamification_GameFixturesSubStep_HomeTeam')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="score1"
        :title="$t('Gamification_GameFixturesSubStep_HomeTeamScore')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="participant2.name"
        :title="$t('Gamification_GameFixturesSubStep_AwayTeam')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="score2"
        :title="$t('Gamification_GameFixturesSubStep_AwayTeamScore')"
        :sortable="false"
        :filterable="false"
      />
      <rest-list-column
        prop="start_time"
        :title="$t('Gamification_GameFixturesSubStep_KickoffUTC')"
        :is-range="false"
        :filter-date-range="false"
        :filter-date="true"
        :date-picker-props="datePickerProps"
      >
        <template v-slot:default="scope">
          <p v-if="scope.row.start_time">
            {{ castDate(scope.row.start_time) }}
          </p>
        </template>
      </rest-list-column>
      <rest-list-column-actions data-qa="column-actions">
        <template slot="header" slot-scope="{}">
          <div class="settings">
            <icon class="settings-icon" glyph="cog" size="20" />
          </div>
        </template>

        <template v-if="!isReadOnly" slot-scope="scope">
          <rest-list-action
            title="Edit"
            :click="() => editRow(scope.row)"
            icon="el-icon-edit-outline"
            data-qa="btn-edit"
          />
        </template>
      </rest-list-column-actions>
    </rest-list>

    <game-fixtures-form-dialog
      v-if="isOpenFixtureFormDialog"
      :initial-state-model="editFixtureModel"
      :dialog-visible="isOpenFixtureFormDialog"
      :game-campaign-id="gameCampaignId"
      @close="closeFixtureFormDialog"
      data-qa="fixture-form-dialog"
    />
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList.vue'
import RestListColumn from '@/common/components/rest/RestListColumn.vue'
import { projectEndpoint } from '@/core/helpers'
import RestListAction from '@/common/components/rest/RestListAction.vue'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions.vue'
import GameFixturesFormDialog from '@/modules/gamification/components/games-campaigns/analytics/GameFixturesFormDialog.vue'
import { castDate, clearFiltersAndSort } from '@/modules/gamification/helpers'
import { isEqual } from 'lodash'

export default {
  name: 'GameFixturesSubStep',
  components: {
    GameFixturesFormDialog,
    RestListColumnActions,
    RestListAction,
    RestListColumn,
    RestList
  },
  props: {
    gameCampaignId: {
      type: Number
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      isOpenFixtureFormDialog: false,
      editFixtureModel: {},
      fetchEndpoint: null
    }
  },
  created() {
    this.fetchEndpoint = projectEndpoint({
      method: 'get',
      url: `gamify/${this.$route.params.id}/campaign/${this.gameCampaignId}/fixtures`
    })
  },
  computed: {
    datePickerProps() {
      return {
        type: 'date',
        value_format: 'yyyy-MM-dd'
      }
    }
  },
  methods: {
    castDate,
    editRow(row) {
      this.editFixtureModel = row
      this.isOpenFixtureFormDialog = true
    },
    closeFixtureFormDialog() {
      this.isOpenFixtureFormDialog = false
      this.editFixtureModel = undefined

      this.$nextTick(() => {
        if (this.$refs.fixturesList) this.$refs.fixturesList.refresh()
      })
    },
    extractData(responseData) {
      return responseData.data || []
    }
  },

  beforeDestroy() {
    const newQuery = clearFiltersAndSort(this.$route.query)

    if (!isEqual(newQuery, this.$route.query)) {
      this.$router.replace({ query: newQuery })
    }
  }
}
</script>

<style scoped>
.action-buttons {
  float: right;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/analytics/GameFixturesSubStep.vue